import { useState as h, useEffect as s } from "react";
const t = {
  tablet: 768,
  desktop: 1200
};
function r() {
  const [o, d] = h({
    width: window.innerWidth,
    height: window.innerHeight,
    fullHeight: 0,
    fullWidth: 0,
    isMobile: window.innerWidth < t.tablet,
    isTablet: window.innerWidth >= t.tablet && window.innerWidth < t.desktop,
    isDesktop: window.innerWidth >= t.desktop
  });
  return s(() => {
    function n() {
      const { body: i } = document, e = document.documentElement;
      d({
        width: window.innerWidth,
        height: window.innerHeight,
        fullHeight: Math.max(
          i.scrollHeight,
          i.offsetHeight,
          e.clientHeight,
          e.scrollHeight,
          e.offsetHeight
        ),
        fullWidth: Math.max(
          i.offsetWidth,
          i.offsetWidth,
          e.offsetWidth,
          e.offsetWidth,
          e.offsetWidth
        ),
        isMobile: window.innerWidth < t.tablet,
        isTablet: window.innerWidth >= t.tablet && window.innerWidth < t.desktop,
        isDesktop: window.innerWidth >= t.desktop
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), o;
}
export {
  r as useWindowSize
};
//# sourceMappingURL=useWindowSize.js.map
